

const HomeStripeText = () => {
    return (
        <div className="marquee-strip ">
            <div className="marquee-inner">
            <div className="marquee-item">Istanbul Real Estate</div>
            <div className="marquee-item">Turkish Citizenship by Investment</div>
            <div className="marquee-item">Kocaeli Developments</div>
            <div className="marquee-item">Off-Plan Properties</div>
            <div className="marquee-item">International Buyers</div>
            <div className="marquee-item">USD-Denominated Growth</div>
            <div className="marquee-item">Residential Specialists</div>
            <div className="marquee-item">Istanbul Real Estate</div>
            <div className="marquee-item">Turkish Citizenship by Investment</div>
            <div className="marquee-item">Kocaeli Developments</div>
            <div className="marquee-item">Off-Plan Properties</div>
            <div className="marquee-item">International Buyers</div>
            <div className="marquee-item">USD-Denominated Growth</div>
            <div className="marquee-item">Residential Specialists</div>
            </div>
        </div>
    )
}

export default HomeStripeText;